import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/services/";
const url = apiUrl + endPoint;

export async function getCustomerServices(equipmentIds) {
  if (equipmentIds === "") {
    equipmentIds = "None";
  }
  return await http.get(url + "customer/" + equipmentIds);
}

export async function addService(payload) {
  const service = { ...payload };
  delete service.daysToExtend;

  return await http.post(url + "add", service);
}

export async function modifyService(payload, previousServiceId) {
  const service = { ...payload };
  delete service.daysToExtend;

  return await http.post(url + "modify/" + previousServiceId, service);
}

export async function extendService(payload, serviceId) {
  return await http.put(url + "extend/" + serviceId, payload);
}

export async function approveServiceDiscount(serviceId) {
  return await http.put(url + "approve/" + serviceId);
}

export async function changeInvoiceService(payload) {
  const updateData = { ...payload };
  delete updateData.equipmentId;

  return await http.put(url + "changeInvoiceService/", updateData);
}

export async function payInvoiceWithAccountBalance(invoiceId) {
  return await http.post(url + "payInvoiceWithAccountBalance/" + invoiceId);
}

/**
 * @deprecated
 */
export async function verifyOnlinePayment(invoice, platform, reference) {
  if (invoice.type === "Service") {
    return await http.post(
      url + "payInvoice/" + invoice._id + "/" + platform + "/" + invoice.serviceId + "/" + reference
    );
  } else if (invoice.type === "Sale") {
    return await http.post(url + "payInvoice/" + invoice._id + "/" + platform + "/" + reference);
  }
}
